
// @ts-ignore
    import __i18nConfig from '@next-translate-root/i18n'
// @ts-ignore
    import __loadNamespaces from 'next-translate/loadNamespaces'
// @ts-ignore
    
import React from "react";
import useTranslation from "next-translate/useTranslation";
import Trans from "next-translate/Trans";

import { Head } from "@/components/Head";
import { useTheme } from "@/hooks/useTheme";
import { Converter } from "@/containers/Converter";

import { MagicianSection } from "@/sections/MagicianSection";
import { TrustedBySection } from "@/sections/TrustedBySection";
import { SelectFormatSection } from "@/sections/SelectFormatSection";
import { ApiTeaserSection } from "@/sections/ApiTeaserSection";
import { ConversionSection } from "@/sections/ConversionSection";
import { ShareDesignSection } from "@/sections/ShareDesignSection";
import { PricingSection } from "@/sections/PricingSection";

const KeynoteToFigma = () => {
  const { t } = useTranslation();
  const { colors } = useTheme();

  return (
    <>
      <Head
        pageNamespace="page/KeynoteToFigma"
        ogImage="/images/keynote2figma-og-image.jpg"
      />

      <MagicianSection
        title={t("page/KeynoteToFigma:title")}
        subtitle={t("page/KeynoteToFigma:subtitle")}
        magicianLogoFile="figma"
      >
        <Converter disabled />
      </MagicianSection>

      <TrustedBySection />

      <ApiTeaserSection
        title={
          ((
            <Trans
              i18nKey="page/KeynoteToFigma:section/apiTeaser.title"
              components={[<span style={{ color: colors.ORANGE }} key={0} />]}
            />
          ) as unknown) as string
        }
        image={{
          src: "/images/keynote-to-figma.png",
          alt: "Keynote to Figma converter example",
        }}
        backgroundColor={colors.LIGHT_GRAY1}
        cta={{
          title: t("common:actions.signUp"),
        }}
        elements={t(
          "page/KeynoteToFigma:section/apiTeaser.apiTeaserElements",
          null,
          {
            returnObjects: true,
          },
        )}
      />

      <ShareDesignSection
        id="ShareDesignSection"
        title={
          ((
            <Trans
              i18nKey="page/KeynoteToFigma:section/shareDesign.title"
              components={[<span key="0" style={{ color: colors.ORANGE }} />]}
            />
          ) as unknown) as string
        }
        image={{
          src: "/images/keynote-to-figma-converted-file-elements.png",
          alt: t("page/KeynoteToFigma:section/shareDesign.imageAlt"),
        }}
        backgroundColor={colors.LIGHT_GRAY1}
        cta={{
          title: t("page/KeynoteToFigma:section/shareDesign.ctaButton"),
        }}
        elements={[
          {
            id: "ELEMENT#1",
            iconType: "NOTES",
            title: t(
              "page/KeynoteToFigma:section/shareDesign.elements.pathElementsTitle",
            ),
            text: t(
              "page/KeynoteToFigma:section/shareDesign.elements.pathElementsText",
            ),
          },
          {
            id: "ELEMENT#2",
            iconType: "ARROW-BLACK",
            title: t(
              "page/KeynoteToFigma:section/shareDesign.elements.folderStructureTitle",
            ),
            text: t(
              "page/KeynoteToFigma:section/shareDesign.elements.folderStructureText",
            ),
          },
        ]}
      />

      <PricingSection />

      <ConversionSection
        title={t("section/conversion:title")}
        iconBadges={[
          {
            iconType: "SHEETS",
            text: t("section/conversion:badges.supportsGroupLayers"),
          },
          {
            iconType: "SYNC-ICON",
            text: t("section/conversion:badges.convertsComponentsSymbols"),
          },
          {
            iconType: "TV",
            text: t("section/conversion:badges.artboardStyleSupport"),
          },
        ]}
        elements={{
          from: {
            iconType: "KEYNOTE",
            image: "/images/keynote-preview.jpg",
            title: "Keynote Demo Preview",
          },
          to: {
            iconType: "FIGMA",
            image: "/images/figma-preview-slides-new.jpg",
            title: "Figma Demo Preview",
          },
        }}
      />

      <SelectFormatSection title={t("section/selectFormat:title")} />
    </>
  );
};

// Temporal workaround for https://github.com/vercel/next.js/discussions/18396
 async function _getStaticProps() {
  return {
    props: {},
  };
}

export default KeynoteToFigma;


// @ts-ignore
    export async function getStaticProps(ctx) {
// @ts-ignore
        let res = _getStaticProps(ctx)
// @ts-ignore
        if(typeof res.then === 'function') res = await res
// @ts-ignore
        return {
// @ts-ignore
          
// @ts-ignore
          ...res,
// @ts-ignore
          props: {
// @ts-ignore
            ...(res.props || {}),
// @ts-ignore
            ...(await __loadNamespaces({
// @ts-ignore
              ...ctx,
// @ts-ignore
              pathname: '/converter/keynote-to-figma',
// @ts-ignore
              loaderName: 'getStaticProps',
// @ts-ignore
              ...__i18nConfig,
// @ts-ignore
              
// @ts-ignore
            }))
// @ts-ignore
          }
// @ts-ignore
        }
// @ts-ignore
    }
// @ts-ignore
  